import { useQuery } from '@tanstack/react-query';
import { getProductByMpn } from '@util/firestore/products';

export const useDataDepotProduct = (mpn?: string[]) => {
  const query = useQuery({
    queryKey: ['data-depot-product', mpn],
    queryFn: () => getProductByMpn(mpn!),
    enabled: !!mpn?.length,
  });

  return {
    dataDepotProduct: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
